import { useScriptTag } from '@vueuse/core'
import { ref } from 'vue'

const widgetUrl = 'https://widget.transactionlink.io/transactionlink-widget.umd.js'

type WidgetApi = typeof window.transactionlink
type WidgetReadyCb = (api: NonNullable<WidgetApi>) => void

const widgetApi = ref<WidgetApi>()

export default function useWidgetScript(
    widgetReadyCb?: WidgetReadyCb,
) {
    const scriptLoaded = ref(false)
    const { load, unload } = useScriptTag(
        import.meta.env.VITE_WIDGET_SCRIPT_URL || widgetUrl,
        () => {
            scriptLoaded.value = true
        },
        { manual: true },
    )

    const unloadWrapped = () => {
        scriptLoaded.value = false
        widgetApi.value?.unmountWidget()
        widgetApi.value = undefined
        unload()
    }

    const registerWidgetReadyCallback = (widgetReadyCb?: WidgetReadyCb) => {
        window.transactionlink_ready = () => {
            widgetApi.value = window.transactionlink
            widgetReadyCb?.(widgetApi.value!)
        }
    }

    registerWidgetReadyCallback(widgetReadyCb)

    return {
        scriptLoaded,
        load,
        unload: unloadWrapped,
        widgetApi,
        registerWidgetReadyCallback,
    }
}
